/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.programs.modals.confirmUpdateEvent.controllers', [])

.controller('ProgramsModalsConfirmUpdateEventController', ['$scope', '$uibModalInstance', 'SoldQuantity', function($scope, $uibModalInstance, SoldQuantity) {

    $scope.programsModalsConfirmUpdateEvent = {

      model: '',

      init: function() {
        this.model = SoldQuantity;
      },

      done: function() {
        $uibModalInstance.close(true);
      },

      cancel: function () {
        $uibModalInstance.dismiss('cancel');
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.programsModalsConfirmUpdateEvent.init();

}]);
